import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CEProductCustomizationDrawer from './CEProductCustomizationDrawer.jsx';

const parseJSONAttribute = (value) => {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch (error) {
    console.error('Failed to parse JSON attribute:', error);
    return null;
  }
};

const mountProductCustomizationDrawer = () => {
  const element = document.getElementById('product-customization-drawer-react');

  if (!element) {
    console.warn('Product customization drawer root element not found');
    return;
  }

  if (element.dataset.reactMounted === 'true') {
    return;
  }
  element.dataset.reactMounted = 'true';

  const product = parseJSONAttribute(element.getAttribute('data-product'));

  const storeName = element.getAttribute('data-store-name') || 'product-customization-drawer';
  const watchStoreChangesAttr = element.getAttribute('data-watch-store-changes');
  const watchStoreChanges = watchStoreChangesAttr !== 'false';

  const language = element.getAttribute('data-language');
  const locale = element.getAttribute('data-locale');
  const country = element.getAttribute('data-country');
  const market = element.getAttribute('data-market');

  const productHandle = element.getAttribute('data-product-handle') || product?.handle || null;
  const productType = element.getAttribute('data-product-type') || undefined;
  const playerHandle = element.getAttribute('data-player-handle') || undefined;
  const competitionHandle = element.getAttribute('data-competition-handle') || undefined;

  const showProductImageAttr = element.getAttribute('data-show-product-image');
  const showProductImage = showProductImageAttr !== 'false';

  const isAlwaysVisibleAttr = element.getAttribute('data-is-always-visible');
  const isAlwaysVisible = isAlwaysVisibleAttr !== 'false';

  const currency = element.getAttribute('data-currency') || undefined;

  const localization =
    locale || country || market
      ? {
          locale: locale ?? undefined,
          country: country ?? undefined,
          market: market ?? undefined,
        }
      : undefined;

  createRoot(element).render(
    <StrictMode>
      <CEProductCustomizationDrawer
        product={product}
        storeName={storeName}
        watchStoreChanges={watchStoreChanges}
        language={language}
        locale={locale}
        country={country}
        market={market}
        localization={localization}
        productHandle={productHandle}
        productType={productType}
        playerHandle={playerHandle}
        competitionHandle={competitionHandle}
        showProductImage={showProductImage}
        isAlwaysVisible={isAlwaysVisible}
        currency={currency}
      />
    </StrictMode>,
  );
};

mountProductCustomizationDrawer();
